// EditCommentPopover.js
import React, { useRef, useState } from "react"
import { Popover, PopoverBody } from "reactstrap"
import gql from "graphql-tag"
import withApolloClient from "../../withApolloClient"
import ConfirmationPopup from "../../Material/ConfirmationPopup"
import "./EditCommentPopover.css"

const UpdateTaskCommentMutation = gql`
  mutation UpdateTaskComment($input: UpdateTaskCommentMutationInput!) {
    updateTaskComment(input: $input) {
      ok
      errors {
        messages
      }
    }
  }
`

const EditCommentPopover = ({ comment, apolloClient, onEdit }) => {
    const [popoverOpen, setPopoverOpen] = useState(false)
    const [openConfirm, setOpenConfirm] = useState(false)
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState("")
    const [success, setSuccess] = useState("")

    const iconRef = useRef(null)

    const handleArchive = async () => {
        try {
            setLoading(true)
            setError("")
            setSuccess("")

            const input = {
                commentId: comment?.id,
                isArchived: true,
            }

            const res = await apolloClient.mutate({
                mutation: UpdateTaskCommentMutation,
                variables: { input },
                refetchQueries: ["Task"],
            })

            if (res?.data?.updateTaskComment?.ok) {
                setSuccess("Comment Archived Successfully")
                setOpenConfirm(false)
                setPopoverOpen(false)
            } else {
                const err =
                    res?.data?.updateTaskComment?.errors?.[0]?.messages?.join(", ") ||
                    "Archive failed"
                setError(err)
            }
        } catch (err) {
            setError(err.message || "Something went wrong")
        } finally {
            setLoading(false)
        }
    }

    return (
        <div className="edit-comment-popover-wrapper" onClick={(e) => e.stopPropagation()}>
            <i ref={iconRef} className="fa fa-ellipsis-h pointer" aria-hidden="true" onClick={(e) => { e.stopPropagation(); setPopoverOpen((prev) => !prev) }} role="button" tabIndex={0} />
            <Popover
                trigger="legacy"
                className="task-header-menu-popover"
                placement="bottom-end"
                isOpen={popoverOpen}
                target={iconRef.current}
                toggle={() => setPopoverOpen(false)}
            >
                <PopoverBody className="p-0">
                    <ul className="task-header-menu">
                        <li className="menu-item" onClick={() => { onEdit(comment); setPopoverOpen(false) }}>
                            <i className="fa fa-pencil-square-o" />Edit
                        </li>
                        <li className="menu-item" onClick={() => { setOpenConfirm(true); setPopoverOpen(false) }}>
                            <i className="fa fa-archive" />Archive
                        </li>
                    </ul>
                </PopoverBody>
            </Popover>
            <ConfirmationPopup
                open={openConfirm}
                message={"Are you sure you want to archive this comment?"}
                loading={loading}
                handleClose={() => setOpenConfirm(false)}
                action={"Yes"}
                confirmAction={handleArchive}
                color="danger"
                error={error}
                success={success}
            />
        </div>
    )
}

export default withApolloClient(EditCommentPopover)
